export const TagEndpoints = {
    getTags() {
        return `${process.env.API_CLUB_CONTENT}/v4/tags`;
    }
};
export const ContentEndpoints = {
    getContent(pageId) {
        return `${process.env.API_CLUB_CONTENT}/v4/pages/${pageId}`;
    },
    createContent() {
        return `${process.env.API_CLUB_CONTENT}/v4/pages`;
    },
    publishContent() {
        return `${process.env.API_CLUB_CONTENT}/v4/pages/published`;
    },
    updateContent: (pageId) => {
        return `${process.env.API_CLUB_CONTENT}/v4/pages/${pageId}`;
    }
};
